import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({

  logo: {
    maxWidth: 'none',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width:1200px)': {
      minWidth: 0,
      "& img": {
        width: 'auto',
        maxWidth: '200px'
      }
    },
  },

  paper: {
    position: 'absolute',
    width: 400,
    height: 400,
    backgroundColor: '#fff',
    border: '2px solid #000',
    borderRadius: '20px',
    boxShadow: '0px 5px 15px rgba(0,0,0,0.3)',
    padding: '16px 32px 24px',
  },

  button1: {
    position: 'absolute',
    width: '390.23px',
    height: '40.1px',
    left: '6.15px',
    top: '70px',
    background: '#0E97FF',
    color: '#fff',
    borderRadius: "10px",
  },

  loginModalbtn: { 
    width: '390.23px',
    height: '40.1px',
    marginTop: '10px !important',
    marginBottom: '10px !important',
    background: '#0E97FF',
    color: '#fff',
    borderRadius: "10px",
  },

  GridBox: {
    position: 'absolute',
    width: '195px',
    height: '18px',
    left: '140px',
    bottom: '20px',
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#5F5F5F'
  },

  forgottenPin: {
    position: 'absolute',
    width: '85px',
    height: '18px',
    left: '320px',
    top: '260px',
    whiteSpace: 'nowrap',
    color: '#5F5F5F',
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
  },

  Checkbox: {
    position: 'absolute',
    width: '111px',
    height: '20px',
    left: '35px',
    top: '260px',
    whiteSpace: 'nowrap',
    fontFamily: 'Poppins',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    color: '#5F5F5F',
  },

  modalPos: {
    top: `10%`,
    left: `35%`,
    transform: `translate(-20%, -35%)`,
    position: 'absolute',
    width: 400,
    minHeight: 300,
    backgroundColor: '#fff',
    border: '2px solid #000',
    borderRadius: '20px',
    boxShadow: '0px 5px 15px rgba(0,0,0,0.3)',
    padding: '16px 32px 24px',
  },

  loginForm: {
    "& .MuiFormControl-fullWidth": {
      marginTop: '10px'
    }
  },

  registerForm: {
    "& .MuiFormControl-fullWidth": {
      marginTop: '10px'
    }
  }

}));